import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DashboardProfile } from './../../services/network/model/dashboard-profile'

interface IDashboardUserState {
  dashboardUser: DashboardProfile | null
}

const initialState: IDashboardUserState = {
  dashboardUser: null
}

const dashboardUserSlice = createSlice({
  name: 'dashboardUser',
  initialState,
  reducers: {
    setDashboardProfile: (state, action: PayloadAction<{ dashboardUser: DashboardProfile }>) => {
      state.dashboardUser = action.payload.dashboardUser
    },
    clearDashboardUser: (state) => {
      state.dashboardUser = null
    }
  }
})

export const { setDashboardProfile, clearDashboardUser } = dashboardUserSlice.actions
export const dashboardUserReducer = dashboardUserSlice.reducer
